import { ApiExplorerInput } from '@squareup/dex-types-shared-api-explorer';

const apiExplorerInputToFetchBody = (
  input: ApiExplorerInput
): Record<string, unknown> | undefined => {
  if (Object.keys(input.bodyParameters).length === 0) {
    return undefined;
  }

  return input.bodyParameters;
};

const apiExplorerInputToUrlPath = (
  input: ApiExplorerInput,
  path: string
): string => {
  const pathParams = Object.keys(input.pathParameters);

  let newPath = path;
  for (const param of pathParams) {
    if (param in input.pathParameters) {
      newPath = newPath.replace(
        `{${param}}`,
        input.pathParameters[param] as unknown as string
      );
    }
  }

  return newPath;
};

const apiExplorerInputToQueryString = (input: ApiExplorerInput): string => {
  const queryParameters = Object.keys(input.queryParameters);
  if (queryParameters.length === 0) {
    return '';
  }

  const urlSearchParams = new URLSearchParams();

  for (const param of queryParameters) {
    if (param in input.queryParameters) {
      urlSearchParams.append(
        param,
        input.queryParameters[param] as unknown as string
      );
    }
  }

  return `?${urlSearchParams.toString()}`;
};

const apiExplorerInputToFormData = (
  input: ApiExplorerInput,
  body: Record<string, unknown> | undefined,
  supportsFileUpload: boolean
): FormData | undefined => {
  if (!supportsFileUpload) {
    return undefined;
  }

  const formData = new FormData();

  if (body) {
    formData.append('request', JSON.stringify(body));
  }

  if (input.fileParameters?.file) {
    formData.append('file', input.fileParameters.file);
  }

  return formData;
};

export {
  apiExplorerInputToFetchBody,
  apiExplorerInputToUrlPath,
  apiExplorerInputToQueryString,
  apiExplorerInputToFormData,
};
